export default "__VITE_ASSET__DxeOe1RD__"